import { processCourseData } from '@api/hooks/course/utils';
import { addTime } from '@utils/dates';
import { emptyObject, emptyList } from '@constants/empty';
import { getUserModel } from '../utils';

export const processSimilarAndOtherCourses = (
  similarCoursesAndOtherCourses = emptyObject
) => {
  return {
    processed: true,
    ...similarCoursesAndOtherCourses,
    results:
      similarCoursesAndOtherCourses.results?.map((courses) => ({
        ...courses,
        data: courses.data.map((course) => processCourseData(course))
      })) || emptyList
  };
};

export const processClassData = (classData) => ({
  ...classData,
  processed: true,
  slug: classData?.relativeLink?.split('/')[2],
  author: getUserModel(classData?.author || classData?.programme?.author || {}),
  finishedAt:
    classData.finishedAt ||
    addTime(new Date(classData.liveAt), classData.videoDuration, 's').getTime()
});
